module.exports = __webpack_public_path__ + "img/about-image-hsp1.3a34cc49.png";